import React from 'react';
import './PolicyPages.css';

const GrievancePolicy = () => {
  return (
    <div className="policy-page">
      {/* Hero Banner */}
      <section className="policy-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1>Grievance Policy</h1>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <figure className="policy-image">
                <img src="/assets/images/data-protection.svg" alt="Grievance Policy" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-content-inner">
            <p>
              In accordance with the Information Technology Act, 2000 and the
              rules made thereunder, the name and contact details of the
              Grievance Officer are provided below. You may contact the
              Grievance Officer to address any discrepancies and grievances
              you may have with respect to your Information with Track
              Opinion. The Grievance Officer will redress your grievances
              expeditiously.
            </p>

            <h3>Grievance Redressal Officer</h3>
            
            <div className="contact-info">
              <p><strong>Email:</strong> help@trackopinion.com</p>
              <p><strong>Website:</strong> <a href="https://trackopinion.com/" target="_blank" rel="noopener noreferrer">www.trackopinion.com</a></p>
              <p><strong>Address:</strong></p>
              <p>607-608, Tower C,</p>
              <p>Nirvana Courtyard, Sector 50,</p>
              <p>Gurugram, 122018</p>
            </div>

            <h3>Information Required in Your Complaint</h3>
            <p>
              We request you to please provide the following information in
              your complaint:
            </p>

            <ul className="policy-list">
              <li>
                Identification of the information provided by you.
              </li>
              <li>
                Clear statement as to whether the information is personal
                information or sensitive personal information.
              </li>
              <li>
                Your address, telephone number or e-mail address.
              </li>
              <li>
                A statement that you have a good-faith belief that use of the
                information has been processed incorrectly or disclosed
                without authorization, as the case may be.
              </li>
              <li>
                A statement, under penalty of perjury, that the information in
                the notice is accurate, and that you are authorized to act on
                behalf of the owner of the right that is allegedly infringed.
              </li>
            </ul>

            <div className="important-notes">
              <p>
                <strong>Note:</strong> The Company may reach out to you to confirm or discuss certain
                details about your complaint and issues raised.
              </p>
              <p>
                The Company shall not be responsible for any communication, if
                addressed, to any non-designated person in this regard.
              </p>
              <p>
                The Company shall not deal with any complaints/issues addressed
                to the 'Grievance Redressal Officer' which do not relate to
                personal data. Please reach the Company concerning your other
                issues on relevant contact details given on the website.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GrievancePolicy;

